/**
 * DownloadIcon/index.js
 * desc: download icon
 * note: accessible icon-button (button + tooltip) by default; read-only renders a static glyph
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const DownloadIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="download icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.download.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 24 16" xmlns="http://www.w3.org/2000/svg"><path d="M12 0a7.49 7.49 0 0 1 7.35 6.04C21.95 6.22 24 8.36 24 11c0 2.76-2.24 5-5 5H6c-3.31 0-6-2.69-6-6 0-3.09 2.34-5.64 5.35-5.96A7.496 7.496 0 0 1 12 0Zm0 14 5-5h-3V5h-4v4H7l5 5Z" /></svg>
    </IconButton>
);


export default DownloadIcon;
